import React from 'react';
import Select from 'components/Select';
import {
  ROOM_TYPES,
  ROOMS,
  ROOM_TYPE_CODES_FOR_SIZE,
  ALL,
  PREMIUM_ROOM_TYPE_GROUPS
} from 'utils/constants';
import intersection from 'lodash/intersection';
import filter from 'lodash/filter';
import difference from 'lodash/difference';

function RoomTypeSelect({
  value,
  onChange,
  onBlur,
  property,
  isHostBooking,
  ...props
}) {
  const propertyRoomTypes = Object.keys(ROOMS[property]);
  const roomType = Object.keys(ROOM_TYPES);
  const availableRoomTypes = filter(
    roomType,
    type =>
      intersection(propertyRoomTypes, ROOM_TYPE_CODES_FOR_SIZE[type]).length >
        0 || type === ALL
  );

  const filteredAvailableRoomTypes = isHostBooking
    ? difference(availableRoomTypes, PREMIUM_ROOM_TYPE_GROUPS)
    : availableRoomTypes;

  return (
    <Select
      name="roomType"
      value={value}
      onChange={onChange}
      clearable={false}
      backspaceRemoves={false}
      onBlur={() => (onBlur ? onBlur(value) : null)}
      {...props}
      className="openUp"
      options={filteredAvailableRoomTypes.map(type => ({
        value: type,
        label: ROOM_TYPES[type]
      }))}
    />
  );
}

export default RoomTypeSelect;
